// extracted by mini-css-extract-plugin
export default {"head":"head_head__LSbkT","author_image":"head_author_image__2sL43","author_link":"head_author_link__Omg1z","time":"head_time__2tKfK","site":"head_site__4FzCz"};